import { create } from 'zustand';
import useLoadingStore from './use-loading';
import { makeRequest } from 'api/api-client';
import { HTTP } from 'constants/http-method';
import { API_ENDPOINTS } from 'api/endpoints';

const useLeadSourceStore = create((set) => ({
  leadLoading: false,
  totalLeads: 0,
  leadSources: [],
  pagination: {
    pageSize: 10,
    totalItems: 0,
    totalPages: 0,
    currentPage: 1,
  },

  // Function to get lead sources
  getLeadSource: async ({ query = null, successCallback }) => {
    set({ leadLoading: true });
    useLoadingStore.getState().setLoading(true);
    try {
      const { data: response } = await makeRequest(
        HTTP.GET,
        API_ENDPOINTS.GET_LEAD_SOURCE,
        null,
        { query } || {}
      );

      if (response.success) {
        set({
          leadSources: response.data?.data || [],
          totalLeads: response.data?.pagination?.totalLeads || 0,
          pagination: {
            pageSize: response.data?.pagination?.limit,
            totalItems: response.data?.pagination?.total,
            currentPage: response.data?.pagination?.page,
            totalPages: response.data?.pagination?.totalpages,
          },
        });
        successCallback && successCallback();
      }
    } catch (error) {
    } finally {
      set({ leadLoading: false });
      useLoadingStore.getState().setLoading(false);
    }
  },

  // Function to create the lead source
  createLeadSource: async ({ data, successCallback }) => {
    useLoadingStore.getState().setLoading(true);
    try {
      const { data: response } = await makeRequest(
        HTTP.POST,
        API_ENDPOINTS.CREATE_LEAD_SOURCE,
        data
      );

      if (response.success) {
        set((state) => ({
          leadSources: [response.data?.data, ...state.leadSources],
        }));
        successCallback && successCallback(response);
      }
    } catch (error) {
    } finally {
      useLoadingStore.getState().setLoading(false);
    }
  },

  // Function to delete lead source
  deleteLeadSource: async ({ id, successCallback }) => {
    useLoadingStore.getState().setLoading(true);
    try {
      const { data: response } = await makeRequest(
        HTTP.DELETE,
        API_ENDPOINTS.DELETE_LEAD_SOURCE,
        null,
        null,
        id
      );

      if (response.success) {
        set((state) => ({
          leadSources: state.leadSources.filter((source) => source.id !== id),
        }));
        successCallback && successCallback(response);
      }
    } catch (error) {
    } finally {
      useLoadingStore.getState().setLoading(false);
    }
  },

  // Function to update lead source
  updateLeadSource: async ({ id, data, successCallback }) => {
    useLoadingStore.getState().setLoading(true);
    try {
      const { data: response } = await makeRequest(
        HTTP.PUT,
        API_ENDPOINTS.UPDATE_LEAD_SOURCE,
        data,
        null,
        id
      );

      if (response.success) {
        set((state) => {
          // Find the updated lead source
          const updatedLeadSource = state.leadSources.find(
            (source) => source.id === id
          );

          // If the lead source is found, update it and move it to the first position
          if (updatedLeadSource) {
            const updatedLeadSources = [
              { ...updatedLeadSource, ...data }, // Updated lead source
              ...state.leadSources.filter((source) => source.id !== id), // Rest of the lead sources
            ];

            return {
              leadSources: updatedLeadSources,
            };
          }

          // If the lead source is not found, return the state as is
          return state;
        });

        successCallback && successCallback(response);
      }
    } catch (error) {
      // Handle error
    } finally {
      useLoadingStore.getState().setLoading(false);
    }
  },
}));

export default useLeadSourceStore;
